import http from "utils/http"

const placeOrder = payload => http.post("/order/v1/order/", payload)

const getOrderStatus = idOrder => http.get(`/order/v1/order/${idOrder}/status`, undefined, undefined, true, true)

const getCampaignRate = () => http.get(`/order/v1/order/campaingrate/`)

const getOrder = idOrder => http.get(`/order/v1/order/${idOrder}`)

const getInvoiceInfo = invoiceNumber => http.get(`/order/v1/invoice/invoiceinfo/${invoiceNumber}`)

const getInvoiceStatus = invoiceNumber => http.get(`/order/v1/invoice/invoicestatus/${invoiceNumber}`)


export default {
  placeOrder,
  getOrderStatus,
  getCampaignRate,
  getOrder,
  getInvoiceInfo,
  getInvoiceStatus
}



// WEBPACK FOOTER //
// ./src/services/orderService.js